module.exports = __webpack_public_path__ + "static/media/lpi00.095d195a.jpg";